export default {
  ALIAS_LABEL: '{name}網址',
  COMPLETE_ADD_CONFIRM_MESSAGE: '你已完成{name}新增，是否上架讓信眾購買呢？',
  DELETE_CONFIRM_MESSAGE: '確認刪除此{name}？',
  DESCRIPTION_LABEL: '{name}說明',
  OVERLAP_LABEL: '同一時段是否只可進行一項{name}？',
  LEAVE_ADD_CONFIRM_MESSAGE: '尚未完成新增，請問是否確定離開新增{name}？',
  LEAVE_EDIT_CONFIRM_MESSAGE: '確認是否放棄編輯{name}？',
  NAME_LABEL: '{name}名稱',
  STATE_LABEL: '{name}開放購買',
  STATE_OFF_CONFIRM_MESSAGE: '取消上架後客戶將無法查看{name}，請問是否取消下架？',
  STATE_ON_CONFIRM_MESSAGE: '上架後客戶將能報名{name}，請問是否確認上架？',
  TITLE_STATE_AND_DISPLAY: '{name}開放與顯示',
  CHECKOUT_NOTE_LABEL: '{name}自訂備註標題（若無填寫則顯示預設標題：{default}）',
  activity: {
    NAME: '活動',
    STEP_INVENTORY_INTRO: '想要在什麼時候讓客戶參與活動呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
    CHECKOUT_NOTE_LABEL_DEFAULT: '其他備註',
  },
  course: {
    NAME: '課程',
    STEP_INVENTORY_INTRO: '想要在什麼時候開課呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
    CHECKOUT_NOTE_LABEL_DEFAULT: '其他備註',
  },
  service: {
    NAME: '服務項目',
    STEP_INVENTORY_INTRO: '想要在什麼時候讓貴賓預約服務項目呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
    CHECKOUT_NOTE_LABEL_DEFAULT: '過去病史',
  },
  reservation: {
    NAME: '訂位項目',
    STEP_INVENTORY_INTRO: '想要在什麼時候讓客戶訂位呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
    CHECKOUT_NOTE_LABEL_DEFAULT: '用餐目的與其他備註',
  },
  guide: {
    NAME: '導覽',
    STEP_INVENTORY_INTRO: '想要在什麼時候讓開放報名呢呢？可以設定多重時段與重複週期喔！暫不編輯時段，請按離開，完成時段編輯請按下一步。',
    CHECKOUT_NOTE_LABEL_DEFAULT: '參觀目的',
  },
  light: {
    NAME: '點燈',
  },
  treasury: {
    NAME: '補庫',
  },
  puja: {
    NAME: '法會',
  },
  pudu: {
    NAME: '贊普',
  },
  worshipset: {
    NAME: '斗燈',
  },
}
